/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './template-diagnosis.reducer';

export const TemplateDiagnosisDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const templateDiagnosisEntity = useAppSelector(state => state.templateDiagnosis.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="templateDiagnosisDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.templateDiagnosis.detail.title">TemplateDiagnosis</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.id">Id</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.id}</dd>
          <dt>
            <span id="snomedConceptId">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.snomedConceptId">Snomed Concept Id</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.snomedConceptId}</dd>
          <dt>
            <span id="snomedConceptText">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.snomedConceptText">Snomed Concept Text</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.snomedConceptText}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.active">Active</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.templateDiagnosis.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{templateDiagnosisEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateDiagnosis.icd10diagnosis">Icd 10 Diagnosis</Translate>
          </dt>
          <dd>{templateDiagnosisEntity.icd10diagnosis ? templateDiagnosisEntity.icd10diagnosis.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templateDiagnosis.prescription">Prescription</Translate>
          </dt>
          <dd>{templateDiagnosisEntity.prescription ? templateDiagnosisEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/template-diagnosis" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/template-diagnosis/${templateDiagnosisEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TemplateDiagnosisDetail;
